customElements.define('collection-row-section',
  class extends HTMLElement {
    constructor() {
      super();

      const sectionId = this.dataset['rowSectionId']

      let realSection = null

      if (sectionId) {
        realSection = document.getElementById("shopify-section-" + sectionId)
      }

      if (realSection) {
        this.insertAdjacentHTML(
          'beforebegin',
          realSection.outerHTML
        )

        if (!Shopify.designMode) {
          realSection.remove()
          this.remove()
        }
      }
    }
  }
)